import { ApiClient } from "../../api/client";

export const getServerFilter = (Redis) => {
  return async (dispatch, getState) => {
    const { section } = getState();
    const { filter } = getState();

    if (
      Redis /* &&
      Object.keys(filter.params).filter(
        (param) => !["marka", "model", "kuzov"].includes(param),
      ).length === 0 */
    ) {
      const params = [];
      if (filter.params.marka) {
        params.push(filter.params.marka);
      }
      if (filter.params.model) {
        params.push(filter.params.model);
      }
      if (filter.params.kuzov) {
        params.push(filter.params.kuzov);
      }

      const response = await Redis.hget(
        `Filter_cache`,
        `${section.params.sectionId}_${params.join("_")}`,
      );
      if (response) {
        dispatch({ type: "FETCH_FILTER", payload: JSON.parse(response) || {} });
        dispatch({ type: "SET_IS_LOADED", payload: true });
      }
    }
  };
};

export const getFilter = (reset = false) => {
  return async (dispatch, getState) => {
    const { section } = getState();
    const { filter } = getState();
    dispatch({ type: "SET_IS_LOADING", payload: true });
    const response = await ApiClient.catalog.getFilter(
      {
        params: section?.params || {},
        filter: filter?.params || {},
      },
      reset,
    );

    if (!response) {
      dispatch({ type: "FETCH_FILTER", payload: {} });
      dispatch({ type: "SET_IS_LOADED", payload: true });
      dispatch({ type: "SET_IS_LOADING", payload: false });
      return;
    }

    /* Подписи (Bitrix + БД) уже смержены в getFilter.js */
    dispatch({ type: "FETCH_FILTER", payload: response });
    dispatch({ type: "SET_IS_LOADED", payload: true });
    dispatch({ type: "SET_IS_LOADING", payload: false });
  };
};

export const setFilterParams = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER_PARAMS", payload: value });
  };
};

export const setIsFilterLoading = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_IS_LOADING", payload: value });
  };
};
